<template>
  <div>
    <div class="inner-content">
      <Otp />
    </div>
  </div>
  
</template>

<script>
  import { isLogout } from "@/js/commons/commons"
  import { BModal, VBModal, BButton } from 'bootstrap-vue'
  import { required, integer, minLength, maxLength } from "vuelidate/lib/validators"
  import ErrorDialog from '@/js/components/Common/ErrorDialog'
  import { Strings } from "@/js/commons/strings"
  import { mapState } from 'vuex'
  import Otp from '@/js/components/OTP/Otp'

  export default {
    directives: { BModal, VBModal, BButton },
    components: {
      BModal,
      BButton,
      ErrorDialog,
      Otp
    },
    data() {
      return {
        otpCode: null,
        isShowErrorMsg: false,
        Strings,
        submitted: false,
        timer: '',
      }
    },
    validations: {
      otpCode: {
        required,
        integer,
        minLength: minLength(6),
        maxLength: maxLength(6)
      }
    },
    computed: {
      ...mapState({
        otpLoading: state => state.otp.otpLoading,
        errorMsg: state => state.otp.errorMsg,
        fcmToken: state => state.auth.fcmToken,
        statusOTP: state => state.otp.statusOTP,
        isAllowed: state => state.otp.isAllowed
      })
    },
    created() {
      if(isLogout()) {
        this.$router.push('/login').catch(()=>{})
      }
    },
    watch: {
      otpLoading() {
        if(this.otpLoading) this.$bvModal.show('otp-modal')
      }
    },
    methods: {
      async onSubmit() {
        this.submitted = true
        this.error = ''
        let self = this
        this.$v.otpCode.$touch()
        if (!self.$v.otpCode.$error) {

          await this.$store.dispatch('otp/inputOtp', {
            otp: this.otpCode,
            device_token: this.fcmToken
          })

          if (this.isAllowed) {
            if (!this.errorMsg) {
              this.$bvModal.show('patient-allowed')
            }
          } else {
            if (this.otpLoading) {
              this.$store.dispatch('patient/resetPatientInfo')
            }

            if (!this.fcmToken) {
              if (this.otpLoading) {
                this.timer = setInterval(this.onCheckStatusOTP, 5000)
              } else {
                clearInterval(this.timer)
              }
            }
          }
        }
      },
        hide() {
          this.resetForm()
          this.$store.dispatch("otp/setErrorMsg","")
          this.isShowErrorMsg = this.submitted = false
          if (this.$router.currentRoute.path !== '/' && this.otpLoading) this.$router.push('/')
        },
        goToPatientInfo() {
          this.$bvModal.hide('patient-allowed')
          if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) {
            this.$router.push('/patient/' + this.$store.state.otp.childId)
          } else {
            var currentPath = this.$router.currentRoute.path
            if (currentPath === '/patient') {
              location.reload()
            } else {
              this.$router.push('/patient')
            }
          }
        },
        resetForm() {
          this.otpCode = this.error = null
          this.$v.$reset()
        },
        async onCheckStatusOTP(isAutoCheck = true) {
          const params = {
            one_time_password: this.$store.state.otp.otpCode,
            dr_user_id: this.$store.state.auth.doctorInfo.id,
          }
          await this.$store.dispatch('otp/getStatusOTP', { params: params })

          if (this.statusOTP === 1) {
            if (!this.fcmToken) clearInterval(this.timer)
            this.$bvModal.hide('otp-modal')
            if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) this.$router.push('/patient/' + this.$store.state.otp.childId)
            else {
              var currentPath = this.$router.currentRoute.path
              if (currentPath === '/patient') {
                location.reload()
              } else {
                this.$router.push('/patient')
              }
            }
          } else if (this.statusOTP === 0) {
            if (!this.fcmToken) clearInterval(this.timer)
            this.$bvModal.hide('otp-modal')
            this.$bvModal.show('modal-error')
          } else {
            if (!isAutoCheck) this.isShowErrorMsg = true
          }
        },
        async onCancel() {
          const params = {
            otp: this.$store.state.otp.otpCode,
            dr_user_id: this.$store.state.auth.doctorInfo.id,
          }
          await this.$store.dispatch('otp/cancelOTP', params)
          if (!this.fcmToken) {
            var highestIntervalId = setInterval(";")
            for (var i = 0 ; i < highestIntervalId ; i += 1) {
              clearInterval(i)
            }
          }
          this.$bvModal.hide('otp-modal')
        }
    }
  }
</script>
